import React from 'react';
import cx from 'classnames';
import { Container } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import ViewNumberBlock from './Block/ViewBlock';

const View = ({ data }) => {
  return (
    <div className="block-numbers">
      <div
        className={cx('block-numbers-wrapper site--preset-wrapper', {
          'has-background': data.backgroundImage,
          'full-width': data.fullWidth,
          ['site--preset-bg-' + data.bg_color]: data.bg_color,
        })}
      >
        {data.backgroundImage && (
          <div
            className="background"
            style={{
              backgroundImage: `url(${flattenToAppURL(
                data.backgroundImage,
              )}/@@images/image)`,
            }}
          ></div>
        )}
        <Container>
          <div
            className={cx('numbers-wrapper', {
              ['site--preset-wrapper site--preset-bg-' +
              data.bg_color]: data.backgroundImage,
            })}
          >
            {data?.numbers?.map((numberBlock, i) => (
              <ViewNumberBlock data={numberBlock} key={i} />
            ))}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default View;
